import Consts from '@/common/consts'
export default {
  HOT_SEARCH: `${Consts.API_HOST_MAIN}/adJd/qryHotKw`, // 热门搜索
  SEARCH: `${Consts.API_HOST_MAIN}/adJd/searchGoodsBykw`, // 搜索
  
  TAB_LIST: `${Consts.API_HOST_MAIN}/adJd/qryTab`, // tab菜单

  TAB_GOODS_LIST: `${Consts.API_HOST_MAIN}/adJd/qryTabGoods`, // tab菜单对应的商品列表

  GOODS_DETAIL: `${Consts.API_HOST_MAIN}/adJd/qryAdGoodsDetail`, // 商品详情
  GOODS_DETAIL_BUY_URL: `${Consts.API_HOST_MAIN}/adJd/qryGoodsBuyUrl`, // 查询商品购买url

  BEAN_BALANCE: `${Consts.API_HOST_MAIN}/adJd/qryGoldenBeans`, // 金豆合计
  BEAN_LIST: `${Consts.API_HOST_MAIN}/adJd/qryGoldenBeansList`, // 金豆列表
  SETTLED_PROFIT_BALANCE: `${Consts.API_HOST_MAIN}/adJd/qryCommissionEnrolled`, // 已结算收益合计
  SETTLED_PROFIT_LIST: `${Consts.API_HOST_MAIN}/adJd/qryCommissionEnrolledList`, // 已结算收益列表
  UNSETTLED_PROFIT_BALANCE: `${Consts.API_HOST_MAIN}/adJd/qryCommissionUnbooked`, // 待结算收益合计
  UNSETTLED_PROFIT_LIST: `${Consts.API_HOST_MAIN}/adJd/qryCommissionUnbookedList`, // 待结算收益列表
  
  ORDER_LIST: `${Consts.API_HOST_MAIN}/adJd/qryOrders`, // 我的订单
  TEAM_ORDER_LIST: `${Consts.API_HOST_MAIN}/adJd/qryTeamOrders`, // 团队订单
}
